(() => {
  const MOBILE_BREAKPOINT = 749;
  const root = document.querySelector('product-info[id^="MainProduct-"]');

  if (!root) return;

  const sectionId = root.dataset.section;

  let ticking = false;
  let stickyBar = null;

  /*
   * Ein expliziter ?variant=-Link gilt als bewusste Variantenauswahl.
   * Ein normaler Produktaufruf dagegen nicht.
   */
  let sizeChoiceMade = new URLSearchParams(window.location.search).has('variant');

  const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;

  const getOriginalButton = () =>
    document.getElementById(`ProductSubmitButton-${sectionId}`) ||
    root.querySelector('.product-form__submit[name="add"]');

  const getVariantIdInput = () =>
    root.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"].product-variant-id'
    );

  const getPriceText = () => {
    const priceRoot = document.getElementById(`price-${sectionId}`);

    if (!priceRoot) return '';

    const price = priceRoot.querySelector(
      '.price.price--on-sale .price-item--sale, .price__regular .price-item--regular'
    );

    return price?.textContent?.replace(/\s+/g, ' ').trim() || '';
  };

  const getOptionName = (group) => {
    const inputWithName = group.querySelector('[data-option-name]');

    if (inputWithName?.dataset.optionName) {
      return inputWithName.dataset.optionName.trim();
    }

    return (
      group.querySelector('legend, .form__label')
        ?.textContent
        ?.replace(':', '')
        ?.trim() || ''
    );
  };

  const isSizeGroup = (group) => {
    const normalized = getOptionName(group).toLowerCase();

    return ['größe', 'groesse', 'size'].some((name) =>
      normalized.includes(name)
    );
  };

  const getSizeGroup = () => {
    const groups = root.querySelectorAll(
      'variant-selects .product-form__input'
    );

    return Array.from(groups).find(isSizeGroup) || null;
  };

  const getSizeChoiceCount = () => {
    const group = getSizeGroup();

    if (!group) return 0;

    const radios = group.querySelectorAll('input[type="radio"]');

    if (radios.length) {
      return radios.length;
    }

    const select = group.querySelector('select');

    if (!select) return 0;

    return Array.from(select.options).filter(
      (option) => option.value !== ''
    ).length;
  };

  const productNeedsExplicitSize = () => {
    return Boolean(getSizeGroup() && getSizeChoiceCount() > 1);
  };

  const sizeNeedsSelection = () => {
    if (!productNeedsExplicitSize()) return false;

    const group = getSizeGroup();

    if (!group) return false;

    const radios = group.querySelectorAll('input[type="radio"]');

    if (radios.length) {
      return !group.querySelector('input[type="radio"]:checked');
    }

    const select = group.querySelector('select');

    return Boolean(select && !select.value);
  };

  const isSizeControl = (target) => {
    if (!(target instanceof HTMLElement)) return false;

    const group = target.closest('.product-form__input');

    if (!group || !isSizeGroup(group)) return false;

    return (
      (target.matches('input[type="radio"]') && target.checked) ||
      target.matches('select')
    );
  };

  const clearSizeSelection = () => {
    const group = getSizeGroup();

    if (!group) return;

    /*
     * Button-/Radio-Picker
     */
    group.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.checked = false;
      input.removeAttribute('checked');
    });

    /*
     * Dropdown-Picker
     */
    const select = group.querySelector('select');

    if (select) {
      let placeholder = select.querySelector(
        'option[data-kc-size-placeholder]'
      );

      if (!placeholder) {
        placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Größe wählen';
        placeholder.disabled = true;
        placeholder.dataset.kcSizePlaceholder = 'true';

        select.prepend(placeholder);
      }

      Array.from(select.options).forEach((option) => {
        option.removeAttribute('selected');
      });

      placeholder.selected = true;
      placeholder.setAttribute('selected', 'selected');

      select.value = '';
    }
  };

  const setOriginalButtonToChooseSize = () => {
    const button = getOriginalButton();

    if (!button) return;

    button.disabled = true;

    const label = button.querySelector('span');

    // DOM-Beobachter darf nur bei wirklichen Textänderungen erneut reagieren.
    if (label && label.textContent !== 'Größe wählen') {
      label.textContent = 'Größe wählen';
    }
  };

  const enforceExplicitSizeSelection = () => {
    if (!productNeedsExplicitSize()) {
      root.classList.remove('kc-size-selection-required');
      return;
    }

    const variantInput = getVariantIdInput();

    /*
     * Solange noch nie bewusst eine Größe gewählt wurde,
     * entfernen wir jede automatische Dawn-Auswahl erneut.
     *
     * Das ist wichtig, weil Dawn z. B. nach einer Farbänderung
     * erneut die erste verfügbare Größe setzen kann.
     */
    if (!sizeChoiceMade) {
      clearSizeSelection();

      if (variantInput) {
        variantInput.value = '';
      }

      setOriginalButtonToChooseSize();

      root.classList.add('kc-size-selection-required');

      return;
    }

    /*
     * Größe wurde gewählt, aber Dawn lädt die Variante noch.
     * Bis eine echte Variant-ID vorhanden ist, bleibt der Kauf gesperrt.
     */
    if (!variantInput?.value) {
      setOriginalButtonToChooseSize();

      root.classList.add('kc-size-selection-required');

      return;
    }

    /*
     * Eine echte Variante ist jetzt gesetzt.
     * Dawn übernimmt ab hier wieder die normale Buttonlogik
     * (Warenkorb / Ausverkauft).
     */
    const button = getOriginalButton();

    root.classList.toggle(
      'kc-size-selection-required',
      Boolean(button?.disabled)
    );
  };

  const scrollToSize = () => {
    const group = getSizeGroup();

    if (!group) return;

    group.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    window.setTimeout(() => {
      const target = group.querySelector(
        'input:not(:disabled), select:not(:disabled)'
      );

      target?.focus({
        preventScroll: true
      });
    }, 450);
  };

  const createStickyBar = () => {
    if (stickyBar) return stickyBar;

    stickyBar = document.createElement('div');
    stickyBar.className = 'kc-mobile-sticky-cart';
    stickyBar.setAttribute(
      'aria-label',
      'Schneller Warenkorb'
    );

    stickyBar.innerHTML = `
      <div class="kc-mobile-sticky-cart__inner">
        <div
          class="kc-mobile-sticky-cart__price"
          data-kc-sticky-price
        ></div>

        <button
          type="button"
          class="kc-mobile-sticky-cart__button"
          data-kc-sticky-button
        >
          In den Warenkorb
        </button>
      </div>
    `;

    document.body.appendChild(stickyBar);

    stickyBar
      .querySelector('[data-kc-sticky-button]')
      .addEventListener('click', () => {
        if (sizeNeedsSelection()) {
          scrollToSize();
          return;
        }

        const originalButton = getOriginalButton();

        if (!originalButton || originalButton.disabled) {
          return;
        }

        originalButton.click();
      });

    return stickyBar;
  };

  const syncStickyContent = () => {
    const bar = createStickyBar();

    const stickyPrice = bar.querySelector(
      '[data-kc-sticky-price]'
    );

    const stickyButton = bar.querySelector(
      '[data-kc-sticky-button]'
    );

    const originalButton = getOriginalButton();

    if (!originalButton || !stickyButton) {
      return;
    }

    if (stickyPrice) {
      stickyPrice.textContent = getPriceText();
    }

    if (sizeNeedsSelection()) {
      stickyButton.textContent = 'Größe wählen';
      stickyButton.disabled = false;
      stickyButton.classList.remove('is-disabled');
      return;
    }

    const originalText =
      originalButton
        .querySelector('span')
        ?.textContent
        ?.trim();

    stickyButton.textContent =
      originalText || 'In den Warenkorb';

    stickyButton.disabled =
      originalButton.disabled;

    stickyButton.classList.toggle(
      'is-disabled',
      originalButton.disabled
    );
  };

  const syncStickyVisibility = () => {
    const bar = createStickyBar();
    const originalButton = getOriginalButton();

    if (!isMobile() || !originalButton) {
      bar.classList.remove('is-visible');
      return;
    }

    const rect =
      originalButton.getBoundingClientRect();

    const passedOriginalButton =
  rect.bottom < 0;

const footer =
  document.querySelector('.knockout-brutal-footer');

const footerHasStarted =
  footer &&
  footer.getBoundingClientRect().top <
    window.innerHeight;

bar.classList.toggle(
  'is-visible',
  passedOriginalButton && !footerHasStarted
);
  };

  const compactSingleColorOptions = () => {
    root
      .querySelectorAll(
        'variant-selects .product-form__input'
      )
      .forEach((group) => {
        const optionName = getOptionName(group);

        const normalized =
          optionName.trim().toLowerCase();

        const isColor = [
          'farbe',
          'color',
          'colour'
        ].some((name) =>
          normalized.includes(name)
        );

        if (!isColor) return;

        const radios =
          group.querySelectorAll(
            'input[type="radio"]'
          );

        const select =
          group.querySelector('select');

        const optionCount =
          radios.length ||
          select?.options?.length ||
          0;

        if (optionCount !== 1) {
          group.classList.remove(
            'kc-mobile-single-option-source'
          );

          if (
            group.nextElementSibling?.classList.contains(
              'kc-mobile-single-option'
            )
          ) {
            group.nextElementSibling.remove();
          }

          return;
        }

        let value = '';

        if (radios.length === 1) {
          value = radios[0].value;
        }

        if (
          select?.options?.length === 1
        ) {
          value =
            select.options[0].textContent.trim();
        }

        if (!value) return;

        group.classList.add(
          'kc-mobile-single-option-source'
        );

        let compact =
          group.nextElementSibling;

        if (
          !compact?.classList.contains(
            'kc-mobile-single-option'
          )
        ) {
          compact =
            document.createElement('div');

          compact.className =
            'kc-mobile-single-option';

          group.insertAdjacentElement(
            'afterend',
            compact
          );
        }

        if (
          !compact.querySelector(
            '.kc-mobile-single-option__label'
          )
        ) {
          compact.innerHTML = `
            <span class="kc-mobile-single-option__label">
              Farbe:
            </span>
            <strong class="kc-mobile-single-option__value"></strong>
          `;
        }

        const valueElement =
          compact.querySelector(
            '.kc-mobile-single-option__value'
          );

        if (
          valueElement &&
          valueElement.textContent !== value
        ) {
          valueElement.textContent = value;
        }
      });
  };

  const softenCompareButton = () => {
    root
      .querySelectorAll(
        '[data-kc-compare-add]'
      )
      .forEach((button) => {
        const label =
          button.querySelector(
            '[data-kc-compare-button-label]'
          );

        if (!label) return;

        if (
          !button.dataset.kcOriginalDefaultLabel
        ) {
          button.dataset.kcOriginalDefaultLabel =
            button.dataset.defaultLabel ||
            label.textContent.trim();
        }

        if (isMobile()) {
          button.dataset.defaultLabel =
            'Modelle vergleichen →';

          if (
            button.getAttribute('aria-pressed') !==
              'true' &&
            label.textContent !==
              button.dataset.defaultLabel
          ) {
            label.textContent =
              button.dataset.defaultLabel;
          }
        } else {
          button.dataset.defaultLabel =
            button.dataset
              .kcOriginalDefaultLabel;

          if (
            button.getAttribute('aria-pressed') !==
              'true' &&
            label.textContent !==
              button.dataset.defaultLabel
          ) {
            label.textContent =
              button.dataset.defaultLabel;
          }
        }
      });
  };

  const hideZeroReviewBadges = () => {
    root
      .querySelectorAll('.jdgm-prev-badge')
      .forEach((badge) => {
        const number =
          badge.getAttribute(
            'data-number-of-reviews'
          );

        const text =
          badge.textContent
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();

        const hasZeroReviews =
          number === '0' ||
          /\bno reviews\b/.test(text) ||
          /\b0 reviews?\b/.test(text);

        badge.classList.toggle(
          'kc-mobile-zero-reviews',
          hasZeroReviews
        );
      });
  };

  const sync = () => {
    ticking = false;

    compactSingleColorOptions();
    softenCompareButton();
    hideZeroReviewBadges();

    /*
     * Muss vor dem Sticky-Sync laufen,
     * damit eine automatisch gesetzte Größe zuerst entfernt wird.
     */
    enforceExplicitSizeSelection();

    syncStickyContent();
    syncStickyVisibility();
  };

  const requestSync = () => {
    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(sync);
  };

  createStickyBar();

  /*
   * Initial sofort verhindern, dass XXS als bewusste
   * Kundenauswahl behandelt wird.
   */
  enforceExplicitSizeSelection();

  sync();

  window.addEventListener(
    'scroll',
    requestSync,
    {
      passive: true
    }
  );

  window.addEventListener(
    'resize',
    requestSync,
    {
      passive: true
    }
  );

  root.addEventListener(
    'change',
    (event) => {
      /*
       * Nur eine tatsächliche Interaktion mit der Größenoption
       * hebt die Sperre auf.
       */
      if (isSizeControl(event.target)) {
        sizeChoiceMade = true;
      }

      window.setTimeout(
        requestSync,
        80
      );

      window.setTimeout(
        requestSync,
        350
      );

      window.setTimeout(
        requestSync,
        700
      );
    }
  );

  const observer =
    new MutationObserver(requestSync);

  observer.observe(root, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();